<template>
  <div class="container">
    <div class="log-form">
      <h2>{{ title }}</h2>
      <b-form @submit="onSubmit" @reset="onReset">
        <slot></slot>
        <b-alert v-model="errorMessage" variant="danger" dismissible>{{
          errorMessage
        }}</b-alert>
        <div style="min-height: 20px; margin-right: -30px;">
          <back-button
            v-show="showBack"
            text="Back"
            v-on:clicked="$emit('prev')"
            style="float: left; width: 120px"
          />
          <next-button
            v-show="showNext"
            v-bind:text="nextText || 'Next'"
            v-on:next="onSubmit"
            id="next-button"
            style="float: right; width: 120px; margin-right:30px;"
          />
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import backButton from "./backButton";
import nextButton from "./nextButton";
export default {
  props: {
    errorMessage: String,
    title: String,
    showBack: Boolean,
    showNext: Boolean,
    nextText: String,
  },
  components: {
    nextButton,
    backButton,
  },
  methods: {
    onSubmit(evt) {
      this.$emit("next");
    },
    onReset(evt) {
      evt.preventDefault();
      this.$emit("reset");
    },
  },
};
</script>
<style>
.alert {
  margin-top: 5px;
}
.log-form {
  background: #fff;
  margin-top: 15px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
}
@media (max-width: 40em) {
  .log-form {
    width: 95%;
    position: relative;
    margin: 2.5% auto 0 auto;
    left: 0%;
    -webkit-transform: translate(0%, 0%);
    -moz-transform: translate(0%, 0%);
    -o-transform: translate(0%, 0%);
    -ms-transform: translate(0%, 0%);
    transform: translate(0%, 0%);
  }
  .log-form form {
    max-height: 70vh;
    overflow: scroll;
  }
}
.log-form form {
  display: block;
  width: 100%;
  padding: 2em;
}
.log-form h2 {
  text-align: left;
  color: #db9c94;
  background-color: black;
  font-size: 1.35em;
  display: block;
  width: 100%;
  padding: 0.75em 1em 0.75em 1.5em;
  box-shadow: inset 0px 1px 1px rgba(255, 255, 255, 0.05);
  border: 1px solid #1d1d1d;
  margin: 0;
  font-weight: 800;
}
.log-form .btn {
  display: inline-block;
  color: white;
  margin-right: 0.5em;
  box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.2);
}
.log-form .btn:focus {
  outline: none;
}
</style>
